// Vendor imports
const Immutable = require('immutable')
// Shared imports
const { TYPES: modelTypes } = require('shared/model-types')
// Common Client V2 imports
const PageContextModel = require('client-v2/common/models/page-context/record')
const { keyedReviver } = require('client-v2/common/state/record-reviver')

class FeedStreamMetaRecord extends Immutable.Record({
  nextUrl: null,
  recBatchId: null,
  streamId: null,
  streamKey: null,
  streamType: null,
  // Interleaved feed keys
  mixRecBatchId: null,
  urlRecBatchId: null
}) {
  getRecBatchId(modelType) {
    let recBatchId
    // Handle interleaved rec batches
    switch (modelType) {
      case modelTypes.ARTICLE:
        recBatchId = this.urlRecBatchId
        break
      case modelTypes.MIX:
        recBatchId = this.mixRecBatchId
        break
    }
    // Fall-back to non-interleaved
    return recBatchId || this.recBatchId
  }

  getPageContext(modelType) {
    return new PageContextModel({
      recBatchId: this.getRecBatchId(modelType),
      streamId: this.streamId,
      streamKey: this.streamKey,
      streamType: this.streamType
    })
  }

  getPageContextForFeedItem(feedItem) {
    const { recId } = feedItem.meta
    return this.getPageContext(feedItem.type).merge({ recId })
  }
}

FeedStreamMetaRecord.reviver = keyedReviver(FeedStreamMetaRecord, {
  // No nested data structures
})

module.exports = FeedStreamMetaRecord
